import React, { Component } from 'react'

class AddPhoto extends Component {
    constructor() {
        super()
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    handleSubmit(event) {
        event.preventDefault();
        // console.log(event.target.elements.link.value)
        const imageLink = event.target.elements.link.value
        const description = event.target.elements.description.value
        const post = {
            id: Number(new Date()),
            desc: description,
            imageLink: imageLink
        } 
        if (description && imageLink) {
            this.props.onAddPhoto(post)
            this.props.history.push('/')
        }
    }

    render() {
        return (
            <div>
                <h1>Photowall</h1>
                <div className="form">
                    <form onSubmit={this.handleSubmit}>
                        <input input="text" placeholder="Link" name="link" />
                        <input input="text" placeholder="Description" name="description" />
                        <button>Add Photo</button>
                    </form>
                </div>
            </div>
        )
    }
}


export default AddPhoto